import React from 'react';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { Box, Typography } from '@mui/material';

const CountryCodeSelector = ({ 
  value, 
  onChange, 
  label = "Phone Number", 
  placeholder = "Enter phone number",
  error = false,
  helperText = "",
  disabled = false,
  required = false,
  fullWidth = true,
  sx = {},
  onKeyPress,
  defaultCountry = "AU"
}) => {
  return (
    <Box sx={{ width: fullWidth ? '100%' : 'auto', ...sx }}>
      {label && (
        <Typography 
          variant="body2" 
          sx={{ 
            mb: 1, 
            color: error ? 'error.main' : 'text.primary',
            fontWeight: 500,
            fontSize: '0.875rem'
          }}
        >
          {label} {required && '*'}
        </Typography>
      )}
      
      <Box
        sx={{
          '& .PhoneInput': {
            display: 'flex',
            alignItems: 'center',
            border: error ? '2px solid #d32f2f' : '2px solid #e1e5e9',
            borderRadius: '8px',
            backgroundColor: '#f8f9fa',
            transition: 'all 0.3s ease',
            '&:hover': {
              borderColor: error ? '#d32f2f' : '#006AF9',
              backgroundColor: 'white'
            },
            '&.PhoneInput--focus': {
              borderColor: error ? '#d32f2f' : '#006AF9',
              backgroundColor: 'white',
              boxShadow: `0 0 0 3px ${error ? 'rgba(211, 47, 47, 0.1)' : 'rgba(0, 106, 249, 0.1)'}`
            }
          },
          '& .PhoneInputCountry': {
            display: 'flex',
            alignItems: 'center',
            padding: '8px 12px',
            borderRight: '1px solid #e1e5e9',
            backgroundColor: 'transparent',
            cursor: 'pointer',
            '&:hover': {
              backgroundColor: 'rgba(0, 0, 0, 0.04)'
            }
          },
          '& .PhoneInputCountryIcon': {
            width: '20px',
            height: '15px',
            marginRight: '8px',
            borderRadius: '2px',
            overflow: 'hidden'
          },
          '& .PhoneInputCountrySelectArrow': {
            width: '0',
            height: '0',
            borderLeft: '4px solid transparent',
            borderRight: '4px solid transparent',
            borderTop: '4px solid #666',
            marginLeft: '8px'
          },
          '& .PhoneInputInput': {
            flex: 1,
            border: 'none',
            outline: 'none',
            padding: '12px 16px',
            fontSize: '1rem',
            backgroundColor: 'transparent',
            '&::placeholder': {
              color: '#999'
            }
          },
          '& .PhoneInputInput:disabled': {
            backgroundColor: 'rgba(0, 0, 0, 0.12)',
            cursor: 'not-allowed'
          }
        }}
      >
        <PhoneInput
          international
          countryCallingCodeEditable={false}
          defaultCountry={defaultCountry}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          disabled={disabled}
          onKeyPress={onKeyPress}
        />
      </Box>
      
      {helperText && (
        <Typography 
          variant="caption" 
          sx={{ 
            mt: 0.5, 
            color: error ? 'error.main' : 'text.secondary',
            fontSize: '0.75rem'
          }}
        >
          {helperText}
        </Typography>
      )}
    </Box>
  );
};

export default CountryCodeSelector; 